import { cloneDeep } from 'lodash';
import { savedListTypes } from '../utils';
import {
    SAVED_LISTS_CLEAR_OPEN_LIST,
    SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_FAILURE,
    SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_REQUEST,
    SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_SUCCESS,
    SAVED_LISTS_REQUEST_OPEN_LIST,
    SAVED_LISTS_UPDATE_NOTIFICATION_PREFERENCES_FAILURE,
    SAVED_LISTS_UPDATE_NOTIFICATION_PREFERENCES_REQUEST,
    SAVED_LISTS_UPDATE_NOTIFICATION_PREFERENCES_SUCCESS,
} from '../actions/actionTypes/saved-lists-action-types';

const _ = { cloneDeep };

const initialState = {
    listType: savedListTypes.players.key,
    isLoading: false,
    isLoaded: false,
    isError: false,
    playerLists: [],
    schoolLists: [],
    selectedPlayerListId: null,
    selectedSchoolListId: null,
    savedPlayers: [],
    savedSchools: [],
    playersSortValue: 1,
    schoolsSortValue: 1,
    isCreatingList: false,
    listCreationfailed: false,
    errorMessage: '',
    creatingListName: '',
    saveSearchSuggestions: [],
    notificationsEnabled: false,
    isLoadingNotificationPreferences: false,
    isUpdatingNotificationPreferences: false,
    notificationPreferencesLoaded: false,
    // A list the UI has been asked to open (e.g. the hub Add-Player "View List" toast link).
    // SavedListsTabContent consumes this to open List Detail, then clears it.
    pendingOpenListId: null,
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'SAVED_LISTS:CHANGE_SORT_FILTER':
            if (action.data.listType === savedListTypes.players.key) {
                return {
                    ...state,
                    playersSortValue: action.data.value,
                };
            } if (action.data.listType === savedListTypes.schools.key) {
                return {
                    ...state,
                    schoolsSortValue: action.data.value,
                };
            }
            return {
                ...state,
            };

        case 'SAVED_LISTS:GET_ALL_LISTS':
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                isError: false,
            };
        case 'SAVED_LISTS:GET_ALL_LISTS_SUCCESS':
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                isError: false,
                playerLists: action.data.players ? action.data.players : [],
                schoolLists: action.data.schools ? action.data.schools : [],
            };
        case 'SAVED_LISTS:GET_ALL_LISTS_FAILURE':
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                isError: true,
            };
        case 'SAVED_LISTS:SORT_LISTS':
            return {
                ...state,
                playerLists: action.data.players,
                schoolLists: action.data.schools,
            };
        case 'SAVED_LISTS:CHANGE_LIST_TYPE':
            return {
                ...state,
                listType: action.listType,
            };
        case 'SAVED_LISTS:SET_PLAYER_LIST':
            return {
                ...state,
                savedPlayers: action.data.savedPlayers,
            };
        case 'SAVED_LISTS:SET_SCHOOL_LIST':
            return {
                ...state,
                savedSchools: action.data.savedSchools,
            };
        case 'SAVED_LISTS:SET_SELECTED_LIST_IDS':
            return {
                ...state,
                selectedPlayerListId: action.data.selectedPlayerListId,
                selectedSchoolListId: action.data.selectedSchoolListId,
            };
        case 'SAVED_LISTS:CREATE_LIST':
            return {
                ...state,
                isCreatingList: true,
                listCreationfailed: false,
                errorMessage: '',
                creatingListName: action.data.listname,
            };
        case 'SAVED_LISTS:CREATE_LIST_FAILURE':
            return {
                ...state,
                isCreatingList: false,
                listCreationfailed: true,
                errorMessage: action.data.errorMessage,
            };
        case 'SAVED_LISTS:CREATE_LIST_SUCCESS':
            return {
                ...state,
                isCreatingList: false,
                listCreationfailed: false,
                playerLists: action.data.players,
                schoolLists: action.data.schools,
            };
        case 'SAVED_LISTS:DELETE_LIST':
            return {
                ...state,
                isLoading: true,
            };
        case 'SAVED_LISTS:DELETE_LIST_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'SAVED_LISTS:DELETE_LIST_SUCCESS':
            return {
                ...state,
                isLoading: false,
                playerLists: action.data.players,
                schoolLists: action.data.schools,
            };
        case 'SAVED_LISTS:ADD_PLAYER_TO_LIST':
            return {
                ...state,
                isLoading: true,
            };
        case 'SAVED_LISTS:ADD_PLAYER_TO_LIST_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'SAVED_LISTS:ADD_PLAYER_TO_LIST_SUCCESS':
            return {
                ...state,
                isLoading: false,
            };
        case 'SAVED_LISTS:REMOVE_PLAYER_FROM_LIST':
            return {
                ...state,
                isLoading: true,
            };
        case 'SAVED_LISTS:REMOVE_PLAYER_FROM_LIST_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'SAVED_LISTS:REMOVE_PLAYER_FROM_LIST_SUCCESS':
            return {
                ...state,
                isLoading: false,
            };
        case 'SAVED_LISTS:ADD_SCHOOL_TO_LIST':
            return {
                ...state,
                isLoading: true,
            };
        case 'SAVED_LISTS:ADD_SCHOOL_TO_LIST_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'SAVED_LISTS:ADD_SCHOOL_TO_LIST_SUCCESS':
            return {
                ...state,
                isLoading: false,
            };
        case 'SAVED_LISTS:REMOVE_SCHOOL_FROM_LIST':
            return {
                ...state,
                isLoading: true,
            };
        case 'SAVED_LISTS:REMOVE_SCHOOL_FROM_LIST_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'SAVED_LISTS:REMOVE_SCHOOL_FROM_LIST_SUCCESS':
            return {
                ...state,
                isLoading: false,
            };
        case 'SAVED_LISTS:UPDATE_NOTES':
            return {
                ...state,
                isLoading: true,
            };
        case 'SAVED_LISTS:UPDATE_NOTES_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'SAVED_LISTS:UPDATE_NOTES_SUCCESS':
            return {
                ...state,
                isLoading: false,
            };
        case 'SAVED_LISTS:UPDATE_DATA':
            return {
                ...state,
                playerLists: _.cloneDeep(action.data.players),
                schoolLists: _.cloneDeep(action.data.schools),
            };
        case 'SAVED_LISTS:SEARCH_REQUEST':
            return {
                ...state,
                saveSearchSuggestions: [],
            };
        case 'SAVED_LISTS:SEARCH_SUCCESS':
            return {
                ...state,
                saveSearchSuggestions: action.data,
            };
        case 'SAVED_LISTS:SEARCH_FAILURE':
            return {
                ...state,
                saveSearchSuggestions: [],
            };
        case SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_REQUEST:
            return {
                ...state,
                isLoadingNotificationPreferences: true,
            };
        case SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_SUCCESS:
            return {
                ...state,
                isLoadingNotificationPreferences: false,
                notificationPreferencesLoaded: true,
                notificationsEnabled: action.data.notificationsEnabled,
            };
        case SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_FAILURE:
            return {
                ...state,
                isLoadingNotificationPreferences: false,
                notificationPreferencesLoaded: true,
            };
        case SAVED_LISTS_UPDATE_NOTIFICATION_PREFERENCES_REQUEST:
            return {
                ...state,
                isUpdatingNotificationPreferences: true,
            };
        case SAVED_LISTS_UPDATE_NOTIFICATION_PREFERENCES_SUCCESS:
            return {
                ...state,
                isUpdatingNotificationPreferences: false,
                notificationsEnabled: action.data.notificationsEnabled,
            };
        case SAVED_LISTS_UPDATE_NOTIFICATION_PREFERENCES_FAILURE:
            return {
                ...state,
                isUpdatingNotificationPreferences: false,
            };
        case SAVED_LISTS_REQUEST_OPEN_LIST:
            return {
                ...state,
                pendingOpenListId: action.listId,
            };
        case SAVED_LISTS_CLEAR_OPEN_LIST:
            return {
                ...state,
                pendingOpenListId: null,
            };
        default:
            return state;
    }
}

export default app;
